export const constants = {
  desktopCharacterLimit: 142,
  mobileCharacterLimit: 132,
  ellipsis: '...',
};
